import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { onEditSellerRes } from "./helper";

const requestConfig = { headers: { "content-type": "multipart/form-data" } };

export const editSeller = async (params: { id: number; data: SellerReqT }) =>
  axios.post(Routes.EDIT_SELLER + "/" + params.id, params.data, requestConfig);

export const useEditSeller = () =>
  useMutation({
    mutationKey: [Keys.EDIT_SELLER_MUT],
    mutationFn: editSeller,
    onSuccess: onEditSellerRes,
  });
